export class StudentPropertyModel {
	key: string;
	section: string;
	ui_editable: boolean;
	title: string;
}

export class StudentPropertyValueModel extends StudentPropertyModel {
	value: boolean;
}

export interface StudentPropertyEditArgument {
	key: string;
	value: boolean;
}
